import Phaser from 'phaser';
import {gsap} from 'gsap';

import gameConfig from '../../../config/game';


export default class Dragon{

    constructor(){
        GAME_REF.obj.dragon = this;
        this.scene = GAME_REF.scene;

        this.dragon = null;
        this.egg1 = null;
        this.egg2 = null;

        this.dragonFuwaAnime = null;
        this.shadowFuwaAnime = null;

        this.jumpTimer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    render(){
        this._renderAnime();
    }


    change(){

        this.scene.tweens.add({
            targets: [this.egg1, this.egg2],
            alpha: 0,
            duration: 500,
            ease: 'Cubic.easeOut',
            onComplete:()=>{
                this.egg1.destroy();
                this.egg2.destroy();
                this.egg1 = this.egg2 = null;
            }
        });
    }


    /**
     * ジャンプさせる
     */
    jump(delay=0){
        const initialY = this.dragon.y;

        this.jumpTimer = gsap.delayedCall(delay, ()=>{
            this.jumpTimer = null;

            this.scene.tweens.add({
                targets: this.dragon,
                y: "-=60",
                duration: 450,
                ease: "Circ.easeOut",
                yoyo: true,
                onComplete: () => {
                    this.dragon.y = initialY;
                }
            });
            
            this.scene.tweens.add({
                targets: this.shadow,
                alpha: 0.5, 
                scaleX:0.9,
                scaleY:0.9,
                duration: 450,
                ease: 'Sine.inOut',
                yoyo: true
            });
        });
    }
    

    /**
     * ふわふわさせる
     */
    fuwa(){
        
        this.scene.tweens.add({
            targets: this.dragon,
            y: 650,
            duration: 200,
            ease: "Circ.easeOut",
            onComplete:()=>{

                this.dragonFuwaAnime = this.scene.tweens.add({
                    targets: this.dragon,
                    y: '-=20', 
                    duration: 1000,
                    ease: 'Sine.inOut',
                    yoyo: true,
                    repeat: -1
                });
        
                this.shadowFuwaAnime = this.scene.tweens.add({
                    targets: this.shadow,
                    alpha: 0.5, 
                    scaleX:0.9,
                    scaleY:0.9,
                    duration: 1000,
                    ease: 'Sine.inOut',
                    yoyo: true,
                    repeat: -1
                });
            }
        });
    }

    stopFuwa(){
        this.dragonFuwaAnime.stop();
        this.shadowFuwaAnime.stop();
        this.dragonFuwaAnime = null;
        this.shadowFuwaAnime = null;

        this.scene.tweens.add({
            targets: this.dragon,
            y: 690,
            duration: 200,
            ease: "Circ.easeOut",
        });
        this.scene.tweens.add({
            targets: this.shadow,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 200,
            ease: "Circ.easeOut",
        });
    }


    _init(){
        this.shadow = this.scene.add.image(600, 690, 'dragon_shadow');
        this.shadow.setOrigin(0.5, 1);
        this.shadow.setScale(0.5);
        this.shadow.setVisible(false);

        this.dragon = this.scene.add.image(600, 690, 'dragon');
        this.dragon.setOrigin(0.5, 1);
        this.dragon.setScale(0.5);
        this.dragon.setVisible(false);

        this.kira1 = this.scene.add.sprite(570, 450, 'dragon_kira');
        this.kira2 = this.scene.add.sprite(570, 450, 'dragon_kira');
        this.kira2.setFrame(1);
        this.kira2.alpha = 0;

        this.egg1 = this.scene.add.image(480, 660, 'dragon_egg');

        this.egg2 = this.scene.add.image(875, 520, 'dragon_egg');
        this.egg2.setFrame(1);

        this.egg1.angle = -25;
        this.egg1.x = 600;
        this.egg1.y = 540;
        
        this.egg2.angle = -100;
        this.egg2.setScale(1.1);
        this.egg2.x = 585;
        this.egg2.y = 420;

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    _renderAnime(){

        this.scene.tweens.add({
            targets: this.egg1,
            x: 480,
            y: 660,
            angle: 0,
            duration: 700,
            ease: 'Cubic.easeOut',
        });

        this.scene.tweens.add({
            targets: this.egg2,
            x: 875,
            y: 520,
            scaleX: 1,
            scaleY: 1,
            angle: 0,
            duration: 700,
            delay: 10,
            ease: 'Cubic.easeOut',
        });

        // ドラゴン
        this.shadow.setScale(0.5);
        this.shadow.setVisible(false);
        this.scene.tweens.add({
            targets: this.shadow,
            scaleX: 1,
            scaleY: 1,
            duration: 500,
            delay: 300,
            ease: 'Back.easeOut',
            onStart: ()=>{
                this.shadow.setVisible(true);
            }
        });

        this.dragon.setScale(0.5);
        this.dragon.setVisible(false);
        this.scene.tweens.add({
            targets: this.dragon,
            scaleX: 1,
            scaleY: 1,
            duration: 500,
            delay: 300,
            ease: 'Back.easeOut',
            onStart: ()=>{
                this.dragon.setVisible(true);
            },
            onComplete:()=>{

                this.scene.tweens.add({
                    targets: this.dragon,
                    scaleY: 0.99,
                    duration: 400,
                    ease: 'Sine.easeInOut',
                    yoyo: true, 
                    repeat: -1
                });
            }
        });

        // キラキラ
        this.scene.tweens.add({
            targets: this.kira1,
            alpha: 0,
            duration: 800,
            ease: 'Sine.easInOut',
            yoyo: true, 
            repeat: -1
        });
        this.scene.tweens.add({
            targets: this.kira2,
            alpha: 1,
            duration: 800,
            ease: 'Sine.easeInOut',
            yoyo: true, 
            repeat: -1
        });
    }


    _pause(){
        if(this.jumpTimer) this.jumpTimer.pause();
    }

    _resume(){
        if(this.jumpTimer) this.jumpTimer.resume();
    }
}